import { Injectable, Signal, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

export interface BreadcrumbItem {
  label: string;
  url: string;
}

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
  private readonly router = inject(Router);

  private readonly navigationEnd = toSignal(
    this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)),
  );

  readonly items: Signal<BreadcrumbItem[]> = computed(() => {
    this.navigationEnd();
    return this.buildBreadcrumb(this.router.routerState.snapshot.root);
  });

  private buildBreadcrumb(snapshot: ActivatedRouteSnapshot, parentUrl = ''): BreadcrumbItem[] {
    const segment = snapshot.url.map((s) => s.path).join('/');
    const url = segment ? `${parentUrl}/${segment}` : parentUrl;
    const label = snapshot.data['breadcrumb'] as string | undefined;

    const current: BreadcrumbItem[] = label ? [{ label, url: url || '/' }] : [];

    return snapshot.firstChild ? [...current, ...this.buildBreadcrumb(snapshot.firstChild, url)] : current;
  }
}
